import { render, staticRenderFns } from "./scrollImage.vue?vue&type=template&id=a4b47298"
import script from "./scrollImage.vue?vue&type=script&lang=js"
export * from "./scrollImage.vue?vue&type=script&lang=js"
import style0 from "./scrollImage.vue?vue&type=style&index=0&id=a4b47298&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports